import { render, staticRenderFns } from "./ServiceTaxes.vue?vue&type=template&id=f56cf510"
import script from "./ServiceTaxes.vue?vue&type=script&lang=js"
export * from "./ServiceTaxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports